import {useDispatch, useSelector} from 'react-redux';
import React, {useEffect, useState} from 'react';
import {DiaryRootState} from 'appRoot/rootReducer';
import classNames from 'classnames';
import style from './style.module.scss';
import {ThunkDispatch} from '@reduxjs/toolkit';
import {getAccountDetails} from 'app/reducers/auth/slice';
import CircularProgress from '@material-ui/core/CircularProgress';
import VenueSelectorList from 'app/common/VenueSelectorList/VenueSelectorList';


export default function LoginRoot() {

  const showNewVenueSelector = useSelector((state: DiaryRootState) => state.rootDisplayReducer.showNewVenueSelector);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  const [showVenueList, setShowVenueList] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(()=>{
    if (showNewVenueSelector) {
      setIsLoading(true)
      dispatch(getAccountDetails({})).then(() => {
        setShowVenueList(true)
        setIsLoading(false)
      })
    }
  }, [showNewVenueSelector])

  return (
    <>
      {showVenueList && <div
        className={classNames({
          [style.displayVenue]: true,
        })}>
        <VenueSelectorList/>
      </div>}
      {isLoading && (
        <div className={style.loadingContainer}>
          <CircularProgress />
        </div>
      )}
    </>

  )
}
